import { render, staticRenderFns } from "./OrganizationFormEdit.vue?vue&type=template&id=1a3527da&"
import script from "./OrganizationFormEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports